export interface IFormat {
  id: number;
  name: string | null;
}

export interface IMerchandise {
  id: number;
  name: string | null;
}

export enum Format {
  CD = 'CD',
  DVD = 'DVD',
  Vinyl10Inch = '10" Vinyl',
  Vinyl7Inch = '7" Vinyl',
  Vinyl12Inch = '12" Vinyl',
  Cassette = 'Cassette',
  SACD = 'SACD',
  BluRay = 'Blu-ray',
  NoPackaging = 'No Packaging',
  Apparel = 'Apparel',
  Print = 'Print',
  Accessories = 'Accessories',
  HardGoods = 'Hard Goods',
}
